// extracted by mini-css-extract-plugin
module.exports = {"titleAccordion":"Accordion_titleAccordion__2YRcd","mobileMenu":"Accordion_mobileMenu__et5f8"};